import {pendingTask, begin, end} from 'react-redux-spinner';
import ACTIONS from '../constants/actions';
import constants from '../../app/constants';

export const setCurrentRoute = (route: string) => ({
  type: ACTIONS.SET_CURRENT_ROUTE,
  payload: {route}
});

export const setRedirect = (path: string) => ({
  type: ACTIONS.SET_REDIRECT,
  payload: {path}
});

export const redirect = (path: string) => setRedirect(path);

export const resetRedirect = () => ({
  type: ACTIONS.RESET_REDIRECT,
});

export const setFinalLogo = (logo) => ({
  type: ACTIONS.SET_FINAL_LOGO,
  payload: {logo}
});

export const fetchCities = () => ({
  type: ACTIONS.FETCH_CITIES,
  [pendingTask]: begin
});

export const fetchCitiesSuccess = (cities) => ({
  type: ACTIONS.FETCH_CITIES_SUCCESS,
  payload: {cities},
  [pendingTask]: end
});

export const fetchCitiesFailed = () => ({
  type: ACTIONS.FETCH_CITIES_FAILED,
  [pendingTask]: end
});

export const fetchCity = (id) => ({
  type: ACTIONS.FETCH_CITY,
  payload: {id},
  [pendingTask]: begin
});

export const fetchCitySuccess = (city) => ({
  type: ACTIONS.FETCH_CITY_SUCCESS,
  payload: {city},
  [pendingTask]: end
});

export const fetchCityFailed = () => ({
  type: ACTIONS.FETCH_CITY_FAILED,
  [pendingTask]: end
});

export const setCurrentCity = (branchId) => ({
  type: ACTIONS.SET_CURREN_CITY,
  payload: {branchId}
});

export const setCurrentCitySuccess = (city) => ({
  type: ACTIONS.SET_CURREN_CITY_SUCCESS,
  payload: {city}
});

export const setCurrentCityFailed = () => ({
  type: ACTIONS.SET_CURREN_CITY_FAILED,
});


export const fetchHomePageContent = () => ({
  type: ACTIONS.FETCH_HOME_PAGE_CONTENT,
  [pendingTask]: begin
});

export const fetchHomePageContentSuccess = (content) => ({
  type: ACTIONS.FETCH_HOME_PAGE_CONTENT_SUCCESS,
  payload: {content},
  [pendingTask]: end
});

export const fetchHomePageContentFailed = () => ({
  type: ACTIONS.FETCH_HOME_PAGE_CONTENT_FAILED,
  [pendingTask]: end
});


export const fetchPageSettings = () => ({
  type: ACTIONS.FETCH_PAGE_SETTINGS
});

export const fetchPageSettingsSuccess = (settings) => ({
  type: ACTIONS.FETCH_PAGE_SETTINGS_SUCCESS,
  payload: {settings}
});

export const fetchPageSettingsFailed = () => ({
  type: ACTIONS.FETCH_PAGE_SETTINGS_FAILED
});


export const fetchCityInfo = (id) => ({
  type: ACTIONS.FETCH_CITY_INFO,
  payload: {id}
});

export const fetchCityInfoSuccess = (city) => ({
  type: ACTIONS.FETCH_CITY_INFO_SUCCESS,
  payload: {city}
});

export const fetchCityInfoFailed = () => ({
  type: ACTIONS.FETCH_CITY_INFO_FAILED
});




export const fetchStaticPage = (slug) => ({
  type: ACTIONS.FETCH_STATIC_PAGE,
  payload: {slug}
});

export const fetchStaticPageSuccess = (page) => ({
  type: ACTIONS.FETCH_STATIC_PAGE_SUCCESS,
  payload: {page}
});

export const fetchStaticPageFailed = () => ({
  type: ACTIONS.FETCH_STATIC_PAGE_FAILED
});


export const resetStaticPage = () => ({
  type: ACTIONS.RESET_STATIC_PAGE
});




